<template>
  <el-radio-group v-model="internalValue" v-bind="$attrs">
    <el-radio
      v-for="item in options"
      :key="item.value"
      :value="item.value"
      @click="handleClick(item.value)"
    >
      {{ item.label }}
    </el-radio>
  </el-radio-group>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
});
const emits = defineEmits(["change"]);

let value = defineModel();
const internalValue = ref(value);

watch(
  () => value,
  (newValue) => {
    internalValue.value = newValue;
  },
);

// 处理再次点击选项取消选中
const handleClick = async (clickedValue) => {
  if (internalValue.value === clickedValue) {
    setTimeout(() => {
      internalValue.value = null;
      value = internalValue.value;
      emits("change", null);
    }, 10);
  } else {
    setTimeout(() => {
      emits("change", clickedValue);
    }, 10)
  }
};
</script>

<style scoped lang="scss"></style>
